var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.price)?_c('div',{staticClass:"bg-white"},[_c('h2',[_vm._v(_vm._s(_vm._f("currency")(_vm.price)))]),_c('span',{staticClass:"text-xs block float-none text-sh-secondary-darken-25"},[_vm._v(_vm._s(_vm.$t('summary.tax')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }